import { render, staticRenderFns } from "./company.vue?vue&type=template&id=7a9a3432&scoped=true&lang=pug&"
import script from "./company.vue?vue&type=script&lang=js&"
export * from "./company.vue?vue&type=script&lang=js&"
import style0 from "./company.sass?vue&type=style&index=0&id=7a9a3432&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9a3432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!G:/project/goeat/web-donfruta/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs,VContainer})
